export default __webpack_public_path__ + "static/media/dsaIcon.9d83a4a8.svg";